import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import {
  productCustomPricePointListApi,
  productCustomPricePointSaveApi,
} from 'models/productManagement/productCustomPricePoint/Model.ProductCustomPricePoint';

type PriceAdjustmentEditProductCustomPricePointProps = {
  productId: number;
  productCustomPricePointId: number;
  productProvinceGroupId?: number;
  onCancel(): void;
};
export default function PriceAdjustmentEditProductCustomPricePoint(
  props: PriceAdjustmentEditProductCustomPricePointProps
) {
  const { lang } = getLocales();

  const productCustomPricePointApi = useApi({
    action: productCustomPricePointListApi,
    body: { productId: [props.productId] },
  });

  const selected = productCustomPricePointApi?.payload?.data?.find((p) => p.id === props.productCustomPricePointId);
  return (
    <>
      <ModalForm<Api.Core.ProductCustomPricePoint.Save.IRequest>
        subcomponents={ThemeModalFormDefault}
        dependencyArray={[selected]}
        title={lang.group}
        default={selected || { productId: props.productId, productProvinceGroupId: props.productProvinceGroupId }}
        onCancel={props.onCancel}
        onSubmit={async (data) => {
          const saveResponse = await productCustomPricePointSaveApi(data);
          if (saveResponse?.payload) {
            location.reload();
          }
        }}
        validation={(data, errors) => {
          if (!data.customInfoGroup) errors.customInfoGroup = lang.mustNotBeEmpty;
        }}
        render={({ form }) => (
          <>
            <FormWrapper>
              <TextInput
                name="customInfoGroup"
                label={lang.customInfoGroup}
                value={form.data.customInfoGroup}
                error={form.errors.customInfoGroup}
                onChange={form.update}
                icon={<Icon class="if-quill-pen" />}
              />

              <InputWrapper>
                <NumberInput
                  name="minPurchasePriceCAD"
                  label={lang.minPurchasePriceCAD}
                  value={form.data.minPurchasePriceCAD}
                  error={form.errors.minPurchasePriceCAD}
                  onChange={form.update}
                />
                <NumberInput
                  name="maxPurchasePriceCAD"
                  label={lang.maxPurchasePriceCAD}
                  value={form.data.maxPurchasePriceCAD}
                  error={form.errors.maxPurchasePriceCAD}
                  onChange={form.update}
                />
              </InputWrapper>
              <InputWrapper>
                <NumberInput
                  name="minFinancedAmountCAD"
                  label={lang.minFinancedAmountCAD}
                  value={form.data.minFinancedAmountCAD}
                  error={form.errors.minFinancedAmountCAD}
                  onChange={form.update}
                />
                <NumberInput
                  name="maxFinancedAmountCAD"
                  label={lang.maxFinancedAmountCAD}
                  value={form.data.maxFinancedAmountCAD}
                  error={form.errors.maxFinancedAmountCAD}
                  onChange={form.update}
                />
              </InputWrapper>
            </FormWrapper>
          </>
        )}
      />
    </>
  );
}
